import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import LQIQualityAssurance from './LQIQualityAssurance';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  familyType?: CampaignFamilyEnum;
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function LQIQualityAssuranceWrapper({ familyType, onChange, targeting, user, userRoles }: Props) {
  return (
    <TargetingProvider
      familyType={familyType}
      onChange={onChange}
      targeting={targeting}
      user={user}
      userRoles={userRoles}
    >
      <LQIQualityAssurance />
    </TargetingProvider>
  );
}

export default LQIQualityAssuranceWrapper;
